


<div  class="premiereDetailsDiv" fxFlex=100  >


    <div class="mobilePremiereDetails spotlightDetails" fxLayout="column">

         <div class="premiereDateTop">
             <span class="date">{{mobilePremiereDetails.cinejoySpotlightsSchedule[0].scheduleTimeText   | date:'EEEE, MMM d, y, h:mm:ss a'}} {{timezone}}</span>
         </div>

         <div class="premiereHeading">
             <span class="heading">{{mobilePremiereDetails.name}}</span>
             <hr class="premiereHeadingHr"/>
         </div>

         <div class="premiereDescription">
             <p class="premiereInfo" [innerHTML] = "mobilePremiereDetails.description"></p>
             <p class="director">Directed by {{mobilePremiereDetails.directors}}</p>
             <p class="cast">{{mobilePremiereDetails.cast}}</p>

             <div class="details" fxLayout="row wrap" fxLayoutGap="20%">
                 <span class="language">{{mobilePremiereDetails.language}}</span>
                 <span class="country">{{mobilePremiereDetails.country}}</span>
             </div>

             <!-- <div class="tags" fxLayout="row wrap" *ngFor="let tag of tags">
                 <span>{{tag}}</span>
             </div> -->

             <div class="tags" fxLayout="row wrap grid" *ngFor="let tag of mobilePremiereDetails.tags">
                 <span>{{tag}}</span>
             </div>
         </div>

         <div fxLayout="row wrap grid" fxLayoutGap="10px">

             <button (click)="open(mobilePremiereDetails.eventId, mobilePremiereDetails, 'Buy')" class="premierePageButton" *ngIf="!isBuyButtonActive">Buy</button>
             <button class="premierePageButton"(click)="redirect()" [disabled] ="joinButtonDisabled">Join</button>
             <button class="premierePageButton" (click)="openDialog(mobilePremiereDetails)" style="margin-top: 5px;" *ngIf="isBuyButtonActive && joinButtonDisabled">
                <ng-container *ngIf="!exsistingGroup">Create Group</ng-container>
                <ng-container *ngIf="exsistingGroup">Manage Group</ng-container>
            </button>

            </div>

         <div class="premiereDateBottom">
             <span class="date">{{mobilePremiereDetails.cinejoySpotlightsSchedule[0].scheduleTimeText   | date:'EEEE, MMM d, y, h:mm:ss a'}} {{timezone}}</span>
         </div>

     </div>

 </div>

